import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from './global.service';
import { globals } from '../globals';
import { Comissao } from '../models/comissao';

@Injectable({
  providedIn: 'root'
})
export class ComissaoService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarPorFuncionario(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Comissao/BuscarPorFuncionario',
      { params: new HttpParams().set('id', id) });
  }

  consultarComissoes() {
    return this.http.get<Comissao[]>(globals.apiUrl + '/api/Comissao/Lista');
  }

  consultarComissoesComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Comissao/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdComissao(idComissao) {
    return this.http.get<any>(globals.apiUrl + '/api/Comissao/Buscar',
      { params: new HttpParams().set('id', idComissao) });
  }

  salvar(comissao: Comissao) {
    return this.http.post(globals.apiUrl + '/api/Comissao/Salvar', comissao);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Comissao/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
